class GrowthBookExperiment {

	constructor(growthbook) {
		this.growthbook = growthbook;
	}
	run() {
		console.log('GrowthBookExperiment is not defined');
	}
}

export default GrowthBookExperiment;